import React from 'react'
import { SettingRow } from '../setting-row/setting-row'
import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import s from './grade-setting.module.scss'
import { useAvailableGrades } from '@entities/profile/api/useAvailableGrades'
import { queryClient } from '@shared/api/query-client'
import { SupportButton } from '@shared/ui/support-button'

export const GradeSetting = ({methods}) => {
	const {data: profile} = queryClient.getQueryData(['profile'])
	const { data: grades } = useAvailableGrades(profile?.role === 'teacher')

	return (
		<SettingRow withoutBorders title={'Цена за урок'} subtitle={<> Цена указывается за <strong>50 минут </strong> урока до вычета комиссии сервиса. Комиссия - <strong>20%</strong>. Больше информации о комиссии в <a href={process.env.REACT_APP_STORAGE_URL + 'contract.pdf'} target='_blank' rel="noreferrer" download={true}>публичной оферте</a>. 
Чтобы узнать как можно понизить комиссию можете обратиться в <SupportButton label="поддержку" theme="clear" placement='bottom-start' size="small" className={s.supportWrapper} buttonClassName={s.supportButton} /></>}>
				<div className={s.gradesWrapper}>
					<Controller
						name="grade_id"
						control={methods?.control}
						render={({field}) => (
							<>
								{grades?.map(grade => (
									<button className={classNames(s.gradeButton, grade?.id === field?.value ? s.active : '')} key={'grader-' + grade?.id} onClick={() => field.onChange(grade?.id)}>
										<span className={s.gradePrice}>{grade?.price + '₽'}</span>
										<span className={s.gradeLabel}>{grade?.id === field?.value ? 'Выбран' : 'Выбрать'}</span>
									</button>
								))}
							</>
						)}
					/>
				</div>
	</SettingRow>
	)
}
